import { BOGGLE_BLUE_TILE_KIND, BOGGLE_BLUE_TIME_BONUS_MS } from '../kinds'
import type { BoggleSpecialTileDefinition } from '../tileTypes'

export const blueTileDefinition: BoggleSpecialTileDefinition = {
  description: 'Adds +2 seconds when played',
  kind: BOGGLE_BLUE_TILE_KIND,
  label: 'Blue',
  previewFill: '#16466b',
  previewTextColor: '#e0f2ff',
  scoreBonusPerPathPosition: 0,
  timeBonusPerWordMs: BOGGLE_BLUE_TIME_BONUS_MS,
  tileShape: 'circle',
}
